import type { Venue } from '../../types/venue';

export const hjortvikenHotel: Venue = {
  id: 'hjortviken-hotel',
  name: 'Hjortviken Hotel & Conference',
  image: '/assets/images/hjortviken.jpg',
  address: 'Hotellvägen 1, 438 54 Hindås, Sweden',
  coordinates: {
    lat: 57.7067,
    lng: 12.4492
  },
  capacity: {
    min: 10,
    max: 120
  },
  rating: 4.9,
  reviews: Array.from({ length: 557 }, (_, i) => ({
    id: `review-${i}`,
    userId: `user-${i}`,
    rating: 4.9,
    comment: '',
    date: new Date().toISOString()
  })),
  amenities: ['wifi', 'coffee', 'restaurant', 'spa', 'gym'],
  images: [
    '/assets/images/hjortviken.jpg',
    'https://images.unsplash.com/photo-1520250497591-112f2f40a3f4?auto=format&fit=crop&q=80&w=1000',
  ],
  description: {
    en: `<p>Creative meetings in efficient environments with scenic natural views. Here you can accomplish a lot in one day, and when the agenda has been completed and delicious snacks consumed, the pool, running trails, and a wealth of other activities await.</p>
    
    <p>The genuine experience includes a good night's sleep. Review your presentations in a conference room with lake views or with your feet in the pool. Conclude with a group activity, dinner, and crisp bar hangout.</p>
    
    <p>Successes, anniversaries, or kickoffs. We help you according to your company's visions. Our large Pool Club is perfect for all groups, and our unique party venue "The Hot Spot" gives you the feeling of having your own glamorous private nightclub in New York.</p>
    
    <p>Here, we give full focus to what you consider important. Social large spaces, adventure, music, and good food, not to mention technology that actually works. We behind all this are ESS Group, with solid experience in creating destinations where precise conferences have been delivered since 2007. After establishing venues such as Ystad Saltsjöbad, Steam Hotel, Ellery Beach House, Hotel Bellora, and Jacy'z Hotel & Resort, our vision grew from words to a grand declaration: Why not create our own Country Club, an excellent meeting place with spot-on conferences – without distractions.</p>`,
    sv: `<p>Kreativa möten i effektiva miljöer med natursköna vyer. Här hinner ni med mycket på en dag och när agendan avhandlats och goda tilltugg slukats, väntar poolen, löpspåret och en uppsjö av andra aktiviteter.</p>
    
    <p>Den genuina upplevelsen innehåller god sömn. Dra igenom avhandlingarna i ett konferensrum med sjöutsikt eller med fötterna i poolen. Avsluta med en gruppaktivitet, middag och krispigt barhäng.</p>
    
    <p>Framgångar, ett jubileum, eller en kickoff. Vi hjälper dig utefter ditt företags visioner. Stor Pool Club perfekt för alla grupper och vår unika fest-lokal "The Hot Spot" med känslan av att vara din privata glamorösa nattklubb i New York.</p>
    
    <p>Här ges fullt fokus på det ni tycker är viktigt. Sociala stora ytor, äventyr, musik och god mat, för att inte glömma teknik som faktiskt fungerar. Vi som ligger bakom heter ESS Group och har gedigen erfarenhet från skapandet av destinationer, där träffsäkra konferenser levererats sedan 2007. Efter bland annat Ystad Saltsjöbad, Steam Hotel, Ellery Beach House, Hotel Bellora och Jacy'z Hotel & Resort växte vår vision från ord, till en storslagen deklaration: Varför inte skapa vår egen Country Club, en utmärkt mötesplats med träffsäkra konferenser – utan distraktioner.</p>`,
    no: `<p>Kreative møter i effektive miljøer med naturskjønne utsikter. Her rekker dere mye på én dag, og når agendaen er gjennomgått og deilige snacks fortært, venter bassenget, løypene og en rekke andre aktiviteter.</p>
    
    <p>Den genuine opplevelse inkluderer god søvn. Gjennomgå presentasjonene i et konferanserom med sjøutsikt eller med føttene i bassenget. Avslutt med en gruppeaktivitet, middag og hyggelig barmiljø.</p>
    
    <p>Suksesser, jubileer eller kickoffs. Vi hjelper deg i henhold til bedriftens visjoner. Stor Pool Club perfekt for alle grupper og vårt unike festlokale "The Hot Spot" med følelsen av å være din private glamorøse nattklubb i New York.</p>
    
    <p>Her gis det fullt fokus på det dere synes er viktig. Sosiale store områder, eventyr, musikk og god mat, for ikke å glemme teknologi som faktisk fungerer. Vi som står bak heter ESS Group og har solid erfaring fra skapelsen av destinasjoner, hvor treffsikre konferanser har blitt levert siden 2007. Etter blant annet Ystad Saltsjöbad, Steam Hotel, Ellery Beach House, Hotel Bellora og Jacy'z Hotel & Resort vokste vår visjon fra ord, til en storslått erklæring: Hvorfor ikke skape vår egen Country Club, et utmerket møtested med treffsikre konferanser – uten distraksjoner.</p>`,
    da: `<p>Kreative møder i effektive miljøer med naturskønne udsigter. Her når I meget på én dag, og når dagsordenen er gennemgået og lækre snacks fortæret, venter poolen, løberuterne og et væld af andre aktiviteter.</p>
    
    <p>Den ægte oplevelse indeholder god søvn. Gennemgå præsentationerne i et konferencelokale med søudsigt eller med fødderne i poolen. Afslut med en gruppeaktivitet, middag og livligt barmiljø.</p>
    
    <p>Succeser, jubilæer eller kickoffs. Vi hjælper dig i henhold til din virksomheds visioner. Stor Pool Club perfekt til alle grupper og vores unikke festlokale "The Hot Spot" med følelsen af at være din private glamourøse natklub i New York.</p>
    
    <p>Her gives fuldt fokus på det, I synes er vigtigt. Sociale store områder, eventyr, musik og god mad, for ikke at glemme teknologi, der faktisk fungerer. Vi, der står bag, hedder ESS Group og har solid erfaring med at skabe destinationer, hvor præcise konferencer er blevet leveret siden 2007. Efter blandt andet Ystad Saltsjöbad, Steam Hotel, Ellery Beach House, Hotel Bellora og Jacy'z Hotel & Resort voksede vores vision fra ord til en storslået erklæring: Hvorfor ikke skabe vores egen Country Club, et fremragende mødested med præcise konferencer – uden distraktioner.</p>`
  },
  priceRange: {
    min: 1800,
    max: 12000
  },
  recommended: false,
  country: 'se',
  region: 'gothenburg',
  city: 'Hindås',
  factbox: {
    rooms: 150,
    conferenceRooms: 10,
    meetingCapacity: 300,
    features: [
      '2 pools',
      '2 restaurants',
      '6 bars',
      'Playground',
      '180° lake view',
      'Nature activities',
      'Free parking',
      '10 min from airport',
      'Gym'
    ]
  }
};